'use client'

import { useState, useRef, useMemo } from 'react'
import { useTranslations } from 'next-intl'
import { motion, useInView } from 'framer-motion'
import StudentAffairsContactsModal, {
  StudentAffairsContact,
} from '@/components/student-life/StudentAffairsContactsModal/StudentAffairsContactsModal'
import styles from './StudentAffairsCTA.module.css'

const defaultContacts: StudentAffairsContact[] = [
  {
    role: 'أمين شؤون الطلاب',
    name: 'عزة عارف',
    phone: '0145263758',
    whatsappUrl: 'https://wa.me/60145263758',
  },
  {
    role: 'نائب أمين شؤون الطلاب',
    name: 'أحمد أمير',
    phone: '01162291047',
    whatsappUrl: 'https://wa.me/601162291047',
  },
  {
    role: 'الأمين العام',
    name: 'عبدالله عثمان',
    phone: '01139849594',
    whatsappUrl: 'https://wa.me/601139849594',
  },
]

export default function StudentAffairsCTA() {
  const t = useTranslations('VisaGuidePage.cta')
  const [isOpen, setIsOpen] = useState(false)
  const ref = useRef<HTMLElement>(null)
  const inView = useInView(ref, { once: false, margin: '-80px' })

  const contacts = useMemo<StudentAffairsContact[]>(() => {
    try {
      const rawContacts = t.raw('contacts')
      if (Array.isArray(rawContacts) && rawContacts.length > 0) {
        return rawContacts
      }
    } catch {
      // Fallback to defaultContacts
    }
    return defaultContacts
  }, [t])

  return (
    <motion.section
      ref={ref}
      className={styles.helpSection}
      initial={{ opacity: 0, y: 24 }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 24 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      <div className={styles.helpOverlay}>
        <h2 className={styles.helpTitle}>{t('title')}</h2>
        <button className={styles.helpBtn} onClick={() => setIsOpen(true)}>
          {t('button')}
        </button>
      </div>

      <StudentAffairsContactsModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={t('modalTitle')}
        contactsLabel={t('contactsLabel')}
        contacts={contacts}
      />
    </motion.section>
  )
}